import { ACTIONS } from "UTILS/Constants";
import BaseAction from "CONFIG/BaseAction";

//never make this function as arrow function
export class HeaderAction extends BaseAction {
  constructor() {
    super();
    BaseAction.call(this);
  }
  setHeaderIcons(headerIcons) {
    this.dispatch({
      type: ACTIONS.SET_HEADER_ICONS,
      headerIcons: headerIcons
    });
  }

  updateHeaderIconClass(moduleName, classname, textLabelClass) {
    this.dispatch({
      type: ACTIONS.UPDATE_HEADER_ICON_CLASSNAME,
      data: {
        moduleName: moduleName,
        classname: classname,
        textLabelClass: textLabelClass
      }
    });
  }

  clearWebRtcPermissionReplyStatus() {
    this.dispatch({
      type: ACTIONS.SET_WEBRTC_REPLY_PERMISSION_STATUS,
      webRtcPermissionReplyStatus: null
    });
  }
  clearLocationPermissionReplyStatus() {
    this.dispatch({
      type: ACTIONS.LOCATION.SET_LOCATION_REPLY_PERMISSION_STATUS,
      locationPermissionReplyStatus: null
    });
  }
  setIsSnapshotTaken(isSnapshotTaken) {
    this.dispatch({
      type: ACTIONS.SET_SNAPSHOT_TAKEN,
      isSnapshotTaken: isSnapshotTaken
    });
  }
  setLocationPopup = value => {
    this.dispatch({
      type: ACTIONS.LOCATION.START_LOCATION_SHARE,
      value: value,
      isLocationSharing: value
    });
  };
  setShowSnapshot = value => {
    this.dispatch({
      type: ACTIONS.SNAPSHOT.SHOW_SNAPSHOT,
      value: value
    });
  }
  resetSnapshotData() {
    this.dispatch({
      type: ACTIONS.RESET_SNAPSHOT_DATA
    });
  }

  setCallStatus = value =>{
    this.dispatch({
      type: ACTIONS.CALL_STATUS,
      value: value
    })
  }
  //use To display and hide audio/video block
  setCallModalPermission = value =>{
    this.dispatch({
      type: ACTIONS.CALL_MODAL_PERMISSION,
      value: value
    })
  }

  setSnapshotCameraPermissionflag = value =>{
    this.dispatch({
      type: ACTIONS.SNAPSHOT.SET_SNAPSHOT_CAMERA_PERMISSION,
      value: value
    })
  }

  setCameraBusyFlag = value => {
    this.dispatch({
      type: ACTIONS.SET_CAMERA_BUSY_FLAG,
      value: value
    });
  }

  setCallMediaType = value => {
    this.dispatch({
      type: ACTIONS.SET_CALL_MEDIA_TYPE,
      mediaType: value
    });
  }

  setParticipantAdmittedOrRejected = (participantAdmissionDetails) => {
    this.dispatch({ 
      type: ACTIONS.PARTICIPANT_ADMITTED_OR_REJECTED,
      participant: participantAdmissionDetails,
    });
  }

  resetParticipantsPluginInfo = () => {
    this.dispatch({
      type: ACTIONS.RESET_PARTICIPANT_PLUGIN_INFO
    });
  }

  clearSnapshotPermissionReplyStatus() {
    this.dispatch({
      type: ACTIONS.SET_SNASHOT_PERMISSION_STATUS,
      snapshotPermissionStatus: {}
    });
  }

  setIsRecording(recordingFlag) {
    this.dispatch({
      type: ACTIONS.SET_IS_RECORDING,
      value: recordingFlag,
    });
  }

  setIsScreenMasking(screenMaskFlag) {
    this.dispatch({
      type: ACTIONS.SET_IS_SCREEN_MASKING,
      value: screenMaskFlag,
    });
  }

  setRunScreenShare(runScreenShareFlag) {
    this.dispatch({
      type: ACTIONS.SET_RUN_SCREEN_SHARE,
      value: runScreenShareFlag,
    });
  }

  setShowPreviewModal(showPreviewModalFlag) {
    this.dispatch({
      type: ACTIONS.SET_PREVIEW_MODAL,
      value: showPreviewModalFlag,
    });
  }

  setVideoTransform(isTransform) {
    this.dispatch({
      type: ACTIONS.SET_VIDEO_TRANSFORM,
      value: isTransform,
    });
  }

  setPreviewAudio(previewAudio) {
    this.dispatch({
      type: ACTIONS.SET_PREVIEW_AUDIO,
      value: previewAudio,
    });
  }

  setMediaDevice(audioDeviceId, videoDeviceId) {
    this.dispatch({
      type: ACTIONS.SET_MEDIA_DEVICE,
      audioDeviceId,
      videoDeviceId,
    });
  }

  setVideoDevice(videoDeviceId) {
    this.dispatch({
      type: ACTIONS.SET_VIDEO_DEVICE,
      value: videoDeviceId,
    });
  }

  setFacingMode(facingMode) {
    this.dispatch({
      type: ACTIONS.SET_FACING_MODE,
      value: facingMode,
    });
  }

  setVirtualBackground(isVirtualBackground, selectedBackground) {
    this.dispatch({
      type: ACTIONS.SET_VIRTUAL_BACKGROUND,
      isVirtualBackground,
      selectedBackground,
    });
  }

  setIsPresenter(isPresenter) {
    this.dispatch({
      type: ACTIONS.SET_IS_PRESENTER,
      value: isPresenter,
    });
  }

  setIsFullScreenV2(isFullScreenV2) {
    this.dispatch({
      type: ACTIONS.SET_IS_FULLSCREEN_V2,
      value: isFullScreenV2,
    });
  }
}
export default HeaderAction;